import { render, staticRenderFns } from "./DrugsList.vue?vue&type=template&id=f74bfbc8&scoped=true"
import script from "./DrugsList.vue?vue&type=script&lang=js"
export * from "./DrugsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74bfbc8",
  null
  
)

export default component.exports